<template>
  <div>
    <div class="section-title">
      Paso 5. Finaliza tu inversión
    </div>
    <div class="section-content">
      <div class="info-contract">
        <input type="checkbox" v-model="toggle1"> He leído, comprendido y aceptado en su totalidad los <a href="/terms"
        target="_blank">Términos y condiciones de uso de la Plataforma</a>, el <a href="/privacy-policy" target="_blank">
        Aviso de Privacidad de los Datos</a> y el <span @click="downloadContract" style="cursor: pointer;">Contrato
        de inversión</span>, aceptando obligarme en términos de los documentos mencionados.
      </div>
      <div class="info-contract">
        <input type="checkbox" v-model="toggle2"> Declaro bajo protesta de decir verdad que la información y
        documentación proporcionad a Flagship es verídica y no ha sido manipulada o editada de forma alguna, por
        lo que en caso de existir falsedad en ella, tengo pleno conocimiento que se aplicarán las sanciones
        contractuales que correspondan y las penas establecidas en los ordenamientos legales respectivos para
        quienes se conducen con falsedad.
      </div>
      <div class="info-contract">
        <input type="checkbox" v-model="toggle3"> Reconozco y acepto que conozco y entiendo los riesgos que esta
        transacción implica, incluyendo sin limitar la posibilidad de perder el total de mi inversión. Asimismo,
        manifiesto que el monto invertido por mí en este proyecto no afectará ni pondrá en riesgo mi patrimonio de
        manera sustancial.
      </div>
      <div class="info-contract">
        Información importante: Para recibir el retorno de tu inversión, no olvides que deberás llenar todos los datos de tu perfil
      </div>
    </div>
    <div class="section-error" v-if="error">
      <div class="title">Hubo un problema para realizar la transacción</div>
      <div>{{ error.data.description }}</div>
    </div>
    <div class="section-button">
      <div class="button" :class="[ filled  ? '' : 'disabled' ]" @click="submitInvestment">Invertir</div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import axios from 'axios';
import download from 'downloadjs';

const { mapState, mapActions } = createNamespacedHelpers('investment');

export default {
  data() {
    return {
      toggle1: false,
      toggle2: false,
      toggle3: false,
      error: null,
    };
  },
  methods: {
    submitInvestment() {
      if (this.filled) {
        if (this.tokenizedCard) {
          this.createInvestment().then(() => {
            this.$emit('next');
          }).catch((error) => {
            this.error = error.response;
          });
        } else {
          this.createSPEI().then(() => {
            this.$emit('next');
          }).catch((error) => {
            this.error = error.response;
          });
        }
      }
    },
    downloadContract() {
      axios.post('https://api-pruebas.flagship.mx/pdf', { investment: this.totalInvestment }, { responseType: 'blob' })
        .then((response) => {
          download(response.data, 'Contrato.pdf', 'application/pdf');
        });
    },
    ...mapActions([
      'createInvestment',
      'createSPEI',
    ]),
  },
  computed: {
    totalPayment() {
      return ((this.totalInvestment * 1.029) + 7.5).toFixed(2);
    },
    user() {
      return this.$store.state.user.user;
    },
    filled() {
      return this.toggle1 && this.toggle2 && this.toggle3;
    },
    ...mapState([
      'currentProject',
      'totalInvestment',
      'tokenizedCard',
    ]),
  },
};
</script>

<style lang="scss" scoped>
/deep/ .info-label {
  font-size: 14px;
  font-weight: 500;
  margin-top: 14px;
  font-size: 16px !important;
}
/deep/ .info {
  width: 100%;
  margin-top: 5px;
  font-size: 14px;
  font-weight: 400;
  padding: 6px 0 10px 0;
  font-size: 16px !important;
}
.payment-info {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}
.payment-item {
  margin-bottom: 8px;
}
.section-error {
  width: 100%;
  background-color: rgba(255, 0, 0, .5);
  padding: 16px 20px;
  margin: 20px 0;
  border: 1.5px solid red;
  font-size: 14px;
}
.title {
  font-weight: 500;
  margin-bottom: 6px;
}
.section-content {
  flex-direction: column;
}
.info-contract {
  font-size: 14px;
  margin-bottom: 12px;
  line-height: 18px;
  text-align: justify;

  a {
    color: #2c70c1;
    cursor: pointer;
  }
  span {
    color: #2c70c1;
    cursor: pointer;
  }
}
.disabled {
  opacity: .5;
}
</style>
